import { useState, useEffect } from 'react';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { selectColorTheme } from '@yme/utils/common';
export function useBrandColor({ productBlockStrategy, }) {
    const [brandColor, setBrandColor] = useState(colorCoreWhite1000);
    const currentColorTheme = selectColorTheme(productBlockStrategy);
    useEffect(() => {
        if (productBlockStrategy !== undefined) {
            setBrandColor(currentColorTheme);
        }
        return () => {
            setBrandColor(colorCoreWhite1000);
        };
    }, [currentColorTheme, productBlockStrategy]);
    return {
        brandColor,
    };
}
